module.exports = __webpack_public_path__ + "22_iclr.jpg?21a3115fe56ceba7757a80e74253f6a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_iclr.jpg
// module id = 184
// module chunks = 0